import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import Day from 'dayjs'
import { addClass, hasClass, removeClass } from 'utils'
import { features, checkoutID, quickPurchaseID } from 'config'
import { actionsType } from 'config/constants'
import UserActions from 'actions/User'
import CartAction from 'actions/Cart'
import CartService from 'services/Cart'
import CmsService from 'services/CMS'
import NewRelicService from 'services/NewRelic'
import PubSub from 'services/PubSub'
import StorageService from 'services/StorageService/'
import TagManagerService from 'services/TagManager'
import WalletService from 'services/Wallet'
import Loader from 'components/Loader'
import ProductsQuantity from 'components/Header/ProductsQuantity'
import TooltipError from 'components/TooltipError'
import UpdatePhone from './UpdatePhone'
import Product from './Product'
import Price from 'components/Price'
import Totals from './Totals'
import style from './style.scss' //NOSONAR
import LoginService from 'services/Login'
import UserInfoService from 'services/AccountInfo'
import useVariant from 'hooks/useVariant'
import OptimizeService from 'services/Optimize'
import ProductFactories from 'factories/Products';

const messageQuestion = '¿Estás seguro que deseas vaciar el carro?'
let actions = [];
let variants = {};
let gtm = false;
let _quickPurchase = {};

const MiniCartContent = (props) => {
    const { orderForm, loading } = props

    const [actionError, setActionError] = useState(false)
    const [updatePhone, setUpdatePhone] = useState(false)
    const [checkout, setCheckout] = useState(false)
    const [maxAmountPrice, setMaxAmountPrice] = useState('')
    const [minPurchase, setMinPurchase] = useState(false)
    const [userData, setUserData] = useState(StorageService.getSecureItem('userData'))
    const [initCards, setInitCards] = useState(false)
    const [hasDocument, setHasDocument] = useState(false)
    const [quickPurchaseIsValid, setQuickPurchaseIsValid] = useState(false)

    const [variantFastPurchase, setVariantFastPurchase] = useState(null)
    const newVariantFastPurchase = variantFastPurchase === '1';

    const isEmpty = orderForm?.items ? orderForm.items.length === 0 : true
    const address = StorageService.getSecureItem('address');
    const preselectedShippingData = StorageService.getItem('preselected_shipping_method');

    const variant = useVariant(checkoutID);
    const newVariant = variant === '1';

    const quantity = orderForm && orderForm.items && ProductFactories.formatProducts(orderForm.items);

    useEffect(() => {
        return function cleanup() {
            gtm = false;
            _quickPurchase = {};
        }
    }, [])

    useEffect(() => {
        const infoValid = validateData(initCards, hasDocument);
        
        if (infoValid) {
            setQuickPurchaseIsValid(true);
            if (typeof window !== 'undefined' && window.dataLayer) {
                window.dataLayer.push({ event: "optimize.comprarapida" });
            }
            if(variants[quickPurchaseID]){
                setVariantFastPurchase(variants[quickPurchaseID]);
            } else if (quickPurchaseID) {
                OptimizeService.getVariant(quickPurchaseID).then(response => {
                    setVariantFastPurchase(response || "0");

                    if(response){
                        variants[quickPurchaseID] = response;
                    }
                });
            }
        } else {
            setQuickPurchaseIsValid(false)
        }
    }, [initCards, hasDocument])


    const sendGtm = (initCards, hasDocument, _minPurchase) => {
        _quickPurchase = {
            category: 'Identificación de compra rápida',
            actions: '',
            tag: '',
            userId: userData.gtmSegment,
        }

        if(initCards && hasDocument && address && preselectedShippingData && userData?.homePhone && (userData?.termsAcceptanceDate || userData?.terms_acceptance_date)) {

            if(_minPurchase) {
                _quickPurchase.actions = 'Botón no disponible';
                _quickPurchase.tag = 'No cumple monto mínimo';

            } else {
                _quickPurchase.actions = 'Botón disponible';
                _quickPurchase.tag = 'Cumple todos los requisitos';
            }

        } else if(!initCards){
            _quickPurchase.actions = 'Botón no existe';
            _quickPurchase.tag = 'No posee tarjeta ingresada';
            
        } else if(!hasDocument) {
            _quickPurchase.actions = 'Botón no existe';
            _quickPurchase.tag = 'No posee documento RUT';

        } else if(!address) {
            _quickPurchase.actions = 'Botón no existe';
            _quickPurchase.tag = 'No posee dirección';

        } else if(!preselectedShippingData) {
            _quickPurchase.actions = 'Botón no existe';
            _quickPurchase.tag = 'No posee selección de despacho';

        } else if(!userData?.homePhone) {
            _quickPurchase.actions = 'Botón no existe';
            _quickPurchase.tag = 'No posee número de telefono';

        } else if(!(userData?.termsAcceptanceDate || userData?.terms_acceptance_date)) {
            _quickPurchase.actions = 'Botón no existe';
            _quickPurchase.tag = 'No ha aceptado los términos y condiciones';
        }


        TagManagerService.interactionQuickPurchase(_quickPurchase.actions, _quickPurchase.tag, _quickPurchase.category, _quickPurchase.userId);
    };


    const validateData = (initCards, hasDocument) => {
        const infoValid = hasDocument && address && preselectedShippingData && userData?.homePhone && (userData?.termsAcceptanceDate || userData?.terms_acceptance_date);

        return infoValid && initCards;
    }

    const goToCheckout = () => {
        setUserData(StorageService.getSecureItem('userData'))
        let user = StorageService.getSecureItem('userData')

        if (user && !user.tel_update && (!updatePhone || updatePhone === 'false' || updatePhone === 'undefined')) {
            setCheckout(true)
            NewRelicService.sendPageAction({
                action: 'UpdatePhoneInMinicart',
                payload: { status: 'open' },
            })
        } else {
            setCheckout(false)
            TagManagerService.interactionQuickPurchase('Clic',  _quickPurchase.actions, 'Botón continuar', userData.gtmSegment)
            CartService.goToCheckout(props.history, newVariant)
            PubSub.dispatch(actionsType.DRAWER.MINICART_CLOSE)
        }
    }

    const addToList = () => {
        PubSub.dispatch(actionsType.DRAWER.ADDTO_LIST_OPEN, { orderItems: window ? window.orderItems : {} })
    }

    const activeSearch = () => {
        PubSub.dispatch('toggle_search')
        PubSub.dispatch(actionsType.DRAWER.MINICART_CLOSE)

        const $headerSearchContainer = document.querySelector('.header-search-container')
        if (hasClass($headerSearchContainer, 'open')) {
            removeClass($headerSearchContainer, 'open')
        } else {
            addClass($headerSearchContainer, 'open')
        }
    }

    const openEmptyCart = () => {
        PubSub.dispatch('modal_confirmation_open', {
            title: `Vaciar carro`,
            message: messageQuestion,
            cancelBtnText: 'Volver',
            confirmBtnText: 'Vaciar',
            confirmCallback: () => {
                setTimeout(() => {
                    emptyCart()
                }, 0)
            },
        })
    }

    const getValueTotalizers = (id) => {
        const items = orderForm ? orderForm.totalizers.filter((item) => item.id === id) : {}
        return items[0] ? Math.abs(items[0].value) : 0
    }

    const emptyCart = () => {
        TagManagerService.removeAllItemsCart(orderForm.items, 'Mini Cart empty cart')

        const emptyCartPromise = CartAction.clearCart()
            .then((orderFormPromise) => {
                setActionError(!orderFormPromise || orderFormPromise.isOld)
                setTimeout(() => {
                    PubSub.dispatch(actionsType.DRAWER.MINICART_CLOSE)
                }, 2000)
                return orderFormPromise
            })

        PubSub.dispatch('cart_productRemove', { promise: emptyCartPromise })
    }

    const clickOutTooltip = () => {
        setActionError(false)
    }

    const responseUpdatePhone = (response) => {
        setUserData(StorageService.getSecureItem('userData'))
        let user = StorageService.getSecureItem('userData')

        if (typeof response?.value?.results?.value === 'boolean') {
            setTimeout(() => {
                setUpdatePhone(true)
                setCheckout(false)
                CartService.goToCheckout(props.history, newVariant)
            }, 0)
        } else if (response?.value) {
            setTimeout(() => {
                user.tel_update = true
                StorageService.setSecureItem('userData', user)
                setUpdatePhone(true)
                setCheckout(false)
                CartService.goToCheckout(props.history, newVariant)
            }, 0)
        }
    }

    useEffect(() => {
        actions.push(PubSub.register('update_phone_user', responseUpdatePhone))

        return function cleanup() {
            actions.map((token) => PubSub.unregister(token))
            actions = []
        }
    }, [])

    useEffect(() => {
        if (userData) setUpdatePhone(userData.tel_update)
    }, [userData])

    useEffect(() => {
        if (orderForm) {
            CmsService.getOperationsV2().then((data) => {
                if (data?.config_purchase) {
                    let consults = [];
                    const configPurchase = data?.config_purchase?.minimum_purchase ? data.config_purchase.minimum_purchase * 1 : 0;

                    const itemDiscount = orderForm.totalizers.filter((item) => item.id === 'Discounts')
                    const discount = itemDiscount?.length ? itemDiscount[0].value : 0

                    const itemTotalizer = orderForm.totalizers?.filter((item) => item.id === 'Items')
                    const total = itemTotalizer?.length ? itemTotalizer[0].value + discount : 0

                    const _minPurchase = configPurchase > total / 100;

                    if(!_minPurchase && minPurchase) {
                        gtm = false;
                    }

                    if(!minPurchase && _minPurchase) {
                        gtm = false;
                    }

                    if (_minPurchase) {
                        setMinPurchase(configPurchase);
                    } else {
                        setMinPurchase(null)
                    }

                    if (features.fastPurchase && LoginService.isLogged() && !gtm) {
                        gtm = true;
                        consults.push(WalletService.getInitCards())
                        consults.push(UserInfoService.getInitDocument())

                        Promise.all(consults).then(response => {
                            setInitCards(response[0]);
                            setHasDocument(response[1]);

                            sendGtm(response[0], response[1], _minPurchase);
                        })
                    }
                }
            })
        }
    }, [orderForm, newVariantFastPurchase])

    const callbackServices = (phone) => {
        const userData = StorageService.getSecureItem('userData')
        if (phone) {
            let updateUser = {
                email: userData.email,
                firstName: userData.firstName,
                lastName: userData.lastName,
                document: userData.document ? userData.document : '',
                documentType: 'RUT',
                phone: phone,
                corporateName: null,
                tradeName: null,
                corporateDocument: null,
                stateInscription: null,
                corporatePhone: null,
                isCorporate: false,
                profileCompleteOnLoading: false,
                profileErrorOnLoading: false,
                customerClass: null,
            }

            return CartAction.setProfileData(updateUser)
                .then((client) => {
                    if (client?.clientProfileData) {
                        return UserActions.setNumber({
                            phone: '+56' + phone,
                            tel_update: true,
                            tel_update_date: Day().format(),
                        })
                    } else {
                        return Promise.resolve(false)
                    }
                })
        } else {
            return Promise.resolve(false)
        }
    }

    const openDeliverySelector = () => {
        PubSub.dispatch('delivery_selector_open')
        PubSub.dispatch('toggle_minicart', { state: false })
    }

    const alertAmount = (maxAmount, block, closer) => {
        const maxPrice =
            '$ ' +
            Math.round(maxAmount)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.')

        if (block) {
            setMaxAmountPrice(maxPrice)
        } else if (closer) {
            setMaxAmountPrice(false)
            PubSub.dispatch('open_snackbar', {
                Subtitle: `Estás próximo a alcanzar el <strong>monto máximo de ${maxPrice} por día.</strong>`,
                timer: 5000,
                type: 'maxAmountInCart',
            })
        } else {
            setMaxAmountPrice(false)
        }
    }

    const fastPurchase = () => {
        PubSub.dispatch('drawer_quick_purchase_open')
        PubSub.dispatch(actionsType.DRAWER.MINICART_CLOSE);

        const total = orderForm.value / 100;
        TagManagerService.interactionButtonPurchase('Clic', quantity, 'Botón compra rápida', total, userData.gtmSegment);
    }


    if (userData && checkout) {
        return (
            <div className="minicartcontent">
                <UpdatePhone phone={userData.homePhone} callbackServices={callbackServices} />
            </div>
        )
    } else {
        const discount = getValueTotalizers('Discounts')
        const subTotal = getValueTotalizers('Items') - discount
        const disabledPurchase = !subTotal

        return (
            <div className={`minicartcontent ${!loading && !isEmpty ? 'align-start drawer-container' : ''}`}>
                {loading && (
                    <div className="minicartcontent-loader">
                        <Loader />
                    </div>
                )}
                {!loading && isEmpty && (
                    <div className="minicartcontent-empty">
                        <h2 className="minicartcontent-empty-title">Tu carro está vacío</h2>
                        <p className="minicartcontent-empty-text">Navega por las ofertas y categorías</p>
                        <button className="primary-btn minicartcontent-empty-btn" onClick={activeSearch}>Inténtalo aquí</button>
                    </div>
                )}
                {!loading && !isEmpty && (
                    <>
                        <h2 className="drawer-title">Tienes <ProductsQuantity text={true} quantity={quantity} /></h2>
                        <div className="drawer-scroll">
                            <div className="minicartcontent-products">
                                {orderForm?.items.map((item, index) => (
                                    <Product item={item} position={index} key={item.id + index} />
                                ))}
                            </div>
                            <div className="minicartcontent-secondary-actions">
                                <button className="new-link minicartcontent-secondary-actions-save" onClick={addToList}>Guardar como lista</button>
                                <button
                                    className={'new-link minicartcontent-secondary-actions-btn' + (loading ? ' disabled' : '')}
                                    onClick={openEmptyCart}>
                                    {actionError && (
                                        <TooltipError
                                            message="En este momento no podemos completar tu solicitud."
                                            clickOut={clickOutTooltip}
                                        />
                                    )}
                                    Vaciar carro
                                </button>
                            </div>
                        </div>
                        <div className="minicartcontent-actions">
                            {disabledPurchase ? '' : <Totals totalizers={orderForm.totalizers || []} alertAmount={alertAmount} />}
                            {!subTotal && !minPurchase && (
                                <div className="delivery-alert">
                                    En este momento <b>no tenemos horarios disponibles</b> para tu despacho. Puedes <span onClick={() => openDeliverySelector()}>cambiar de modo de entrega</span> para ver más posibilidades.
                                </div>
                            )}
                            {maxAmountPrice && (
                                <div className="express-alert">
                                    Tu pedido excede el <b>monto máximo diario de {maxAmountPrice}.</b> Para continuar edita tu pedido o crea una lista para guardar tus productos.
                                </div>
                            )}
                            {!!minPurchase && (
                                <div className="minimum-alert">
                                    Monto mínimo de compra <b><Price price={minPurchase} /></b>
                                </div>
                            )}
                            <div className={`minicartcontent-buttons ${(features.fastPurchase && newVariantFastPurchase) ? 'fast-purchase' : ''}`}>
                                {quickPurchaseIsValid && newVariantFastPurchase && features.fastPurchase && (
                                    <button
                                        className={`secundary-btn ${minPurchase ? 'disabled' : ''}`}
                                        disabled={!!minPurchase}
                                        onClick={fastPurchase}>
                                        Compra rápida
                                    </button>
                                )}
                                <button className={'primary-btn' + (disabledPurchase ? ' disabled-btn' : '')} onClick={goToCheckout}>
                                    Continuar
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        )
    }
}

MiniCartContent.propTypes = {
    loading: PropTypes.bool,
    orderForm: PropTypes.object,
    quantity: PropTypes.number,
}

export default withRouter(MiniCartContent)
